import React, { PropTypes } from "react";
import { connect } from "react-redux";
import UpcomingWebinarsView from "components/Dashboard/UpcomingWebinars/UpcomingWebinars";
import UpcomingWebinarItem from "components/Dashboard/UpcomingWebinars/UpcomingWebinarItem";
import actions from "actions";
import constants from "constants";
import { push } from "redux-router";
import _ from "lodash";
import axios from "axios";
import { showAddToCalendarModal } from "../../../actions/mixed";

const { UPCOMING_CLIENT_WEBINARS, UPCOMING_WEBINARS } = constants;

const { subscribeWebinarSaga, unsubscribeWebinarSaga } = actions;

class UpcomingWebinars extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: !window.matchMedia("(min-width: 800px)").matches,
      subscriptionEvents: {},
      is_subscription_sponsor: this.props.is_subscription_sponsor || false,
    };
  }

  componentWillReceiveProps(props) {
    if (
      !_.isEqual(
        this.props.webinars.is_subscription_sponsor,
        props.webinars.is_subscription_sponsor
      )
    ) {
      this.setState({
        ...this.state,
        is_subscription_sponsor:
          this.props.is_subscription_sponsor || props.is_subscription_sponsor,
      });
    }
    if (!_.isEqual(this.props.subscriptions, props.subscriptions)) {
      this.setState({
        ...this.state,
        subscriptionEvents: {
          ...this.state.subscriptionEvents,
          ...props.subscriptions,
        },
      });
    }
  }

  toggleSponsorsSubscription = (webinar) => {
    this.setState({
      ...this.state,
      is_subscription_sponsor: !this.state.is_subscription_sponsor,
    });
    axios.put("/api/v1/subscription_sponsors/" + webinar.id);
  };

  webinars = () =>
    this.props.webinars.map((webinar) => {
      return (
        <UpcomingWebinarItem
          key={webinar.id}
          webinar={webinar}
          // subscriptions={this.props.subscriptions}
          subscriptions={this.state.subscriptionEvents}
          is_subscription_sponsor={this.state.is_subscription_sponsor}
          toggleSponsorsSubscription={this.toggleSponsorsSubscription}
          userRole={this.props.userRole}
          onSubscriptionChange={(e, sessionIndex) =>
            this.onSubscriptionChange(e, webinar.id, sessionIndex)
          }
          toggleSubscription={() => this.toggleSubscription(webinar)}
          scrollTo={this.props.scrollTo}
          openAddToCalendarModal={() =>
            this.props.openAddToCalendarModal({ webinarId: webinar.id })
          }
          isMobile={this.state.isMobile}
        />
      );
    });

  onSubscriptionChange = (roomId, webinarId, sessionIndex) => {
    let roomIdByWebinar = this.state.subscriptionEvents[webinarId];
    const roomIdInt = parseInt(roomId);

    if (roomIdByWebinar && roomIdByWebinar.indexOf(roomIdInt) > -1) {
      return;
    }

    roomIdByWebinar = roomIdByWebinar || [];
    roomIdByWebinar[sessionIndex] = roomIdInt;

    this.setState({
      subscriptionEvents: {
        ...this.state.subscriptionEvents,
        [webinarId]: roomIdByWebinar,
      },
    });
  };

  toggleSubscription = (webinar) => {
    const { dispatch, isLogged, slug } = this.props;

    if (!isLogged) {
      if (slug) {
        localStorage.setItem("_url_slug", `${slug}#upcoming`);
      }

      dispatch(push("/users/sign_in"));
      return;
    }

    if (webinar.subscription_id) {
      this.props.unsubscribeWebinar(
        webinar.subscription_id,
        webinar.id,
        "",
        "clientUrl"
      );
    } else {
      this.props.subscribeWebinar(webinar, true, "clientUrl");
    }
  };

  render() {
    return (
      <UpcomingWebinarsView
        nextPage={this.props.nextPage}
        webinars={this.webinars()}
        pagination={this.props.pages > this.props.page}
        count={this.props.count}
      />
    );
  }
}

UpcomingWebinars.propTypes = {
  webinars: PropTypes.array,
  subscribeWebinar: PropTypes.func,
  unsubscribeWebinar: PropTypes.func,
  pages: PropTypes.integer,
};

const mapStateToProps = (state) => ({
  pages: state.clientUrls.list.upcoming.pages,
  subscriptions: state.webinars[UPCOMING_WEBINARS].subscriptions,
  isLogged: !_.isEmpty(state.users.user),
  userRole: state.users.user.user_type,
});

const mapDispatchToProps = (dispatch) => ({
  subscribeWebinar: (webinar, registered = true, source) =>
    dispatch(subscribeWebinarSaga(webinar, registered, source)),
  unsubscribeWebinar: (id, weinbarId, groupId, source) =>
    dispatch(unsubscribeWebinarSaga(id, weinbarId, groupId, source)),
  openAddToCalendarModal: (payload) =>
    dispatch(showAddToCalendarModal(payload)),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(UpcomingWebinars);



// WEBPACK FOOTER //
// ./src/containers/ClientUrlDashboard/UpcomingWebinars/UpcomingWebinars.jsx